// extracted by mini-css-extract-plugin
export default {"CartProducts":"cartProducts_CartProducts__pB3KT"};